import { NOTIFICATION_TYPES, ROLES, ROUTES } from '../../../constants';
import {
    Admin,
    Csm,
    Customer,
    DocumentRequest,
    DashboardIcon,
    Documents,
    DocumentCategory,
    ScoreCard,
    HiringClients,
    Broadcast,
    SafetyMeetingIcon,
    User,
} from '../../../assets/svg';
import PostersIcon from '../../../assets/svg/PostersIcon';

const uptoCSM = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CSM];
const uptoSA = [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.CSM,
    ROLES.CONTENT_MANAGER,
    ROLES.SALES_AGENT,
];
const notCMgr = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CSM, ROLES.SALES_AGENT];
const UPDATED_NOTIFICATION_NAME = {
    DOC_STATUS_CHANGE: 'Document Status Updated',
};

export const sidebarOptions = (sidebarFor) => {
    return sidebarFor === 'admin'
        ? [
              {
                  name: 'Dashboard',
                  icon: DashboardIcon,
                  route: [ROUTES.ADMIN.DASHBOARD],
                  allowedRoles: uptoSA,
              },
              {
                  name: 'Document Categories',
                  icon: DocumentCategory,
                  route: [ROUTES.ADMIN.DOCUMENT_CATEGORY],
                  allowedRoles: uptoCSM,
              },
              {
                  name: 'Documents',
                  icon: Documents,
                  route: [ROUTES.ADMIN.DOCUMENTS],
                  allowedRoles: uptoCSM,
              },
              {
                  name: 'Management',
                  icon: User,
                  route: [],
                  allowedRoles: uptoSA,
                  subOptions: [
                      {
                          name: 'Admins',
                          icon: Admin,
                          route: [ROUTES.ADMIN.ADMIN],
                          allowedRoles: notCMgr,
                      },
                      {
                          name: 'CSMs',
                          icon: Csm,
                          route: [ROUTES.ADMIN.CSM],
                          allowedRoles: uptoSA,
                      },
                      {
                          name: 'Content Managers',
                          icon: Csm,
                          route: [ROUTES.ADMIN.CONTENT_MANAGER],
                          allowedRoles: uptoSA,
                      },
                      {
                          name: 'Sales Agents',
                          icon: Csm,
                          route: [ROUTES.ADMIN.SALES_AGENT],
                          allowedRoles: uptoSA,
                      },
                  ],
              },
              {
                  name: 'Clients',
                  icon: Customer,
                  route: [
                      ROUTES.ADMIN.CUSTOMER,
                      ROUTES.ADMIN.NEWS_FEED_ADMIN,
                      ROUTES.ADMIN.CUSTOMER_EDIT,
                      ROUTES.ADMIN.CUSTOMER_HIRING_CLIENT_ORDER,
                  ],
                  allowedRoles: uptoSA,
              },
              {
                  name: 'Request Document',
                  icon: DocumentRequest,
                  route: [ROUTES.ADMIN.DOCUMENT_REQUEST],
                  allowedRoles: uptoCSM,
              },
              {
                  name: 'Scorecards',
                  icon: ScoreCard,
                  route: [
                      ROUTES.ADMIN.ADMIN_SCORE_CARD_LISTING,
                      ROUTES.ADMIN.SCORE_CARD_REPORT_ADMIN,
                  ],
                  allowedRoles: uptoCSM,
              },
              {
                  name: 'Regulatory Issue',
                  icon: Broadcast,
                  route: [ROUTES.ADMIN.ADMIN_REGULATORY_ISSUE],
                  allowedRoles: notCMgr,
              },
              // Digital Document Library
              {
                  name: 'Digital Document Library',
                  icon: Documents,
                  route: [],
                  allowedRoles: uptoSA,
                  subOptions: [
                      {
                          name: 'Digital Safety Manuals',
                          icon: DocumentCategory,
                          route: [ROUTES.ADMIN.DIGITAL_SAFETY_LIBRARY],
                          allowedRoles: uptoSA,
                      },
                      {
                          name: 'Digital Labor Law Posters',
                          icon: PostersIcon,
                          route: [ROUTES.ADMIN.DIGITAL_LABOR_POSTERS],
                          allowedRoles: uptoSA,
                      },
                      {
                          name: 'Safety Meetings',
                          icon: SafetyMeetingIcon,
                          route: [ROUTES.ADMIN.SAFETY_MEETINGS],
                          allowedRoles: uptoSA,
                      },
                  ],
              },
          ]
        : [
              {
                  name: 'Dashboard',
                  icon: DashboardIcon,
                  route: [ROUTES.CUSTOMER.DASHBOARD],
              },
              {
                  name: 'Documents',
                  icon: Documents,
                  route: [ROUTES.CUSTOMER.DOCUMENTS],
              },
              {
                  name: 'My Documents',
                  icon: DocumentCategory,
                  route: [ROUTES.CUSTOMER.MY_FOLDERS_VIEW, ROUTES.CUSTOMER.MY_DOCUMENTS_VIEW],
              },
              {
                  name: 'Scorecard',
                  icon: ScoreCard,
                  route: [ROUTES.CUSTOMER.SCORE_CARD_LANDING_PAGE],
              },
              {
                  name: 'Accounts',
                  icon: Customer,
                  route: [ROUTES.CUSTOMER.ACCOUNTS],
              },
              {
                  name: 'Hiring Clients',
                  icon: HiringClients,
                  route: [ROUTES.CUSTOMER.HIRING_CLIENTS],
              },
              {
                  name: 'Account Reviews',
                  icon: HiringClients,
                  route: [ROUTES.CUSTOMER.ACCOUNT_REVIEWS],
              },
              {
                  name: 'Digital Document Library',
                  icon: Documents,
                  route: [],
                  subOptions: [
                      {
                          name: 'Digital Safety Manuals',
                          icon: DocumentCategory,
                          route: [ROUTES.CUSTOMER.DIGITAL_SAFETY_LIBRARY],
                      },
                      {
                          name: 'Digital Labor Law Posters',
                          icon: PostersIcon,
                          route: [ROUTES.CUSTOMER.DIGITAL_LABOR_POSTERS],
                      },
                      {
                          name: 'Safety Meetings',
                          icon: SafetyMeetingIcon,
                          route: [ROUTES.CUSTOMER.SAFETY_MEETINGS],
                      },
                  ],
              },
          ];
};

export const getUpdatedNotificationTitle = (notification) => {
    switch (notification.notification_code) {
        case NOTIFICATION_TYPES.DOCUMENT_STATUS_CHANGE:
            return {
                ...notification,
                notification_name: UPDATED_NOTIFICATION_NAME.DOC_STATUS_CHANGE,
            };
        default:
            return notification;
    }
};
